// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_uikit.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import companyMilestones from './routes/companyMilestones';
import draw from './routes/draw';
import alternatingSectionSlider from './routes/alternatingSectionSlider';
import scrollSwiping from './routes/scrollSwiping';
import showcaseSlider from './routes/showcaseSlider';
import tabbedSwitcher from './routes/tabbedSwitcher';
import leadGenSidebar from './routes/leadGenSidebar';
import testListing from './routes/testListing';
import navAnimation from './routes/navAnimation';
import mixedMediaCards from './routes/mixedMediaCards';
import prolarisInteractiveReport from './routes/prolarisInteractiveReport';
import secondaryPageNav from './routes/secondaryPageNav';
import resourcesAjaxFilter from './routes/resourcesAjaxFilter';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  // Company Milestones page
  companyMilestones,
  // blood draw plugin
  draw,
  // Layout - alternating section slider
  alternatingSectionSlider,
  // Layout - scroll snapping
  scrollSwiping,
  // Layout - showcase slider
  showcaseSlider,
  // Layout - tabbed switcher
  tabbedSwitcher,
  // Layout - Sticky CTA / Lead Gen Sidebar
  leadGenSidebar,
  // Component - For test listing container layout
  testListing,
  // Global - Animations for Global Primary Nav (2)
  navAnimation,
  // Global - Mixed media cards turn to slider
  mixedMediaCards,
  // Interactive report - prolaris
  prolarisInteractiveReport,
  // Layout - Secondary page nav
  secondaryPageNav,
  // Resources CPT - Ajax filter
  resourcesAjaxFilter,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js